
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../../componentes/loading/loading";

function ResumoSolicitantes({ data, filtrar, loading, alterarSolicitante }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [filtroSolicitante, setFiltroSolicitante] = useState("");

  useEffect(() => {
    if (data?.totalSolicitantes && Object.keys(data.totalSolicitantes).length > 0) {
      let solicitantes = Object.keys(data.totalSolicitantes);
      let valores = Object.values(data.totalSolicitantes);

      // Aplicar filtro
      if (filtroSolicitante.trim() !== "") {
        solicitantes = solicitantes.filter((label) =>
          label.toLowerCase().includes(filtroSolicitante.toLowerCase())
        );
        valores = solicitantes.map((label) => data.totalSolicitantes[label]);
      }

      // Atualizar nomes sem e-mail com base no filtro
      const solicitantesSplit = solicitantes.map(x => x.split("@")[0]);

      setChartOptions({
        chart: {
          type: "bar",
          toolbar: { show: false },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const index = config.dataPointIndex;
              const label = solicitantes[index]; // e-mail completo para lógica
              alterarSolicitante(label);
            }
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 4,
            horizontal: false,
            columnWidth: "50%"
          }
        },
        dataLabels: { enabled: false },
        xaxis: { categories: solicitantesSplit }, // agora filtrado corretamente
        colors: [
          "#3b3ef6ff", "#33248aff", "#8a5e24ff", "#3c8a24ff",
          "#5a49bdff", "#246a8aff", "#8a2463ff", "#8a4124ff"
        ],
        legend: { show: false }
      });

      setChartSeries([{ name: "Valor Total R$", data: valores }]);
    } else {
      setChartSeries([]);
    }
  }, [data, filtrar, filtroSolicitante]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1 lg:min-h-[425px]">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Solicitações por cada Solicitante
      </h3>
      <div className="flex flex-wrap justify-between">
        <label className="col-md-9 text-muted-foreground text-sm cursor-pointer">
          Apanhado Geral do Valor Gasto por cada Solicitante durante o período.
        </label>

        <input
          type="text"
          value={filtroSolicitante}
          onChange={(e) => setFiltroSolicitante(e.target.value)}
          placeholder="Digite o nome do solicitante"
          className="col-md-3 px-3 py-1 border border-input text-sm rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
        />
      </div>
      {!loading ? (
        data.solicitacoes.length > 0 && chartSeries.length > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="bar"
            height={300}
          />
        ) : (
          "Não existem dados disponíveis para o intervalo selecionado."
        )
      ) : (
        <Loading />
      )}

    </div>
  );
}

export default ResumoSolicitantes;
